import { Form, Input, Modal, ModalProps } from "antd"
import ReactDOM from "react-dom"
import { createPlanPermission, IPlanPermission, updatePlanPermission } from "@/services/plan-permission/plan-permission.service"
import { useEffect } from "react"

interface PlanPermissionModalProps extends ModalProps {
  planPermission?: IPlanPermission
  onSuccess: () => void
}

export function PlanPermissionModal(props: PlanPermissionModalProps) {
  const { onSuccess, onCancel, planPermission } = props
  const [form] = Form.useForm()

  useEffect(() => {
    if (!planPermission) {
      return
    }
    form.setFieldsValue(planPermission || {})
  }, [planPermission])


  return <Modal
      title={planPermission ? 'Edit Plan Permission' : 'Create Plan Permission'}
      width={600}
      open={true}
      onCancel={onCancel}
      onOk={() => form.submit()}
    >
      <Form
        form={form}
        onFinish={async (body) => {
          if (planPermission) {
            await updatePlanPermission(body, planPermission.code)
          } else {
            await createPlanPermission(body)
          }
          onSuccess()
        }}
        className="mt-4"
      >
        <Form.Item label='Code' name='code' rules={[{ required: true, message: 'Please input code' }]}>
          <Input type='text' />
        </Form.Item>
        
        <Form.Item label='Description' name='description' rules={[{ required: true, message: 'Please input description' }]}>
          <Input type='text' />
        </Form.Item>
      </Form>
    </Modal>
}

PlanPermissionModal.show = (props: PlanPermissionModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const clean = () => {
    ReactDOM.unmountComponentAtNode(div)
    div.remove()
  }

  ReactDOM.render(
    <PlanPermissionModal
      {...props}
      onCancel={(e) => {
        props.onCancel?.(e)
        clean()
      }}
      onSuccess={() => {
        props.onSuccess?.()
        clean()
      }}
    />,
    div
  )
}